import { __experimentalFormField as FormField } from '@cp/ds/src/components/form';
import { CatalogItemType } from '@common/model/catalog/item/type';
import React from 'react';
import { FormFieldName } from '../model/form';
import { FilterRangeField } from './filterRangeField';

/** Вакансии: по макету YOU-4741. */
const VACANCY_AGE_MIN = 0;
const VACANCY_AGE_MAX = 70;
/** Резюме: прежние границы возраста специалиста. */
const RESUME_AGE_MIN = 18;
const RESUME_AGE_MAX = 60;

type AgeFieldProps = {
  catalogType: CatalogItemType;
};

export const AgeField: React.FC<AgeFieldProps> = ({ catalogType }) => {
  const isVacancy = catalogType === CatalogItemType.Vacancy;
  const min = isVacancy ? VACANCY_AGE_MIN : RESUME_AGE_MIN;
  const max = isVacancy ? VACANCY_AGE_MAX : RESUME_AGE_MAX;

  return (
    <FormField
      name={FormFieldName.Age}
      render={({ disabled, name }) => (
        <FilterRangeField disabled={disabled} format={(value) => `${value} лет`} max={max} min={min} name={name} step={1} />
      )}
    />
  );
};
